module.exports = "/_next/static/images/CollectDataTabs-2-e5b7ae707cc7b95daea04e600f63b6e3.webp";